import { Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home"; // eager — always the target of "back home" so preload it

const LanePage = lazy(() => import("@/pages/LaneCanvas"));
const UXPage = lazy(() => import("@/pages/UXCanvas"));
const CaseStudy = lazy(() => import("@/pages/CaseStudy"));
const Contact = lazy(() => import("@/pages/Contact"));
const AdminLogin = lazy(() => import("@/pages/admin/Login"));
const AdminDashboard = lazy(() => import("@/pages/admin/Dashboard"));

function App() {
  return (
    <div className="App">
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <AuthProvider>
          <BrowserRouter>
            <Suspense fallback={<div className="min-h-screen bg-void" />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<LanePage lane="products" />} />
                <Route path="/operations" element={<LanePage lane="operations" />} />
                <Route path="/coaching" element={<LanePage lane="coaching" />} />
                <Route path="/development" element={<LanePage lane="development" />} />
                <Route path="/ux" element={<UXPage />} />
                <Route path="/case/:slug" element={<CaseStudy />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
          <Toaster position="bottom-center" theme="dark" />
        </AuthProvider>
      </ReactLenis>
    </div>
  );
}

export default App;
